import { useQuery } from "@tanstack/react-query";
import { getStrategies } from "../services/CurrencyServices/currencyServices";

/**
 * Retrieves a list of currency strategies.
 *
 * @returns {object} An object containing the list of strategies and a boolean indicating whether the request is loading.
 * @property {array} strategies - The list of currency strategies.
 * @property {boolean} isLoading - A boolean indicating whether the request is loading.
 */
const useFetchStrategies = () => {
  const { data: strategies, isLoading } = useQuery({
    queryFn: getStrategies,
    queryKey: ["strategies"],
  });

  return {
    strategies,
    isLoading,
  };
};

export default useFetchStrategies;
